export default class en {
	static translations = {
		labels: {
			logout: "Logout",
			profile: "Profile",
			rowsPerPage: "Rows per page:",
			all: "All",
			noResults: "No results.",
			of: "of",
			selectItem: "Select item",
			from: "from",
			to: "to",
			uploadInProgress: "Upload in progress.",
			person: "Person",
			company: "Company",
			en: "EN",
			hr: "HR",
			totalAmount: "Total Amount",
			showPaymentPlan: "Show payment plan",
			tripStatus: "Trip status",
			confirmed: "Confirmed",
			cancelled: "Cancelled",
			amount: "Amount",
			dueDate: "Due Date",
			amountPaid: "Amount Paid",
			notes: "Notes",
			selectSupplierService: "Select service",
			thirdPartyServices: "3rd party services",
			guestsPaid: "Guests Paid",
			totalBalance: "Total Balance",
			totalIncome: "Total Income",
			totalCost: "Total Cost",
			totalGrossProfit: "Total Gross Profit",
			totalBalanceDue: "Total Balance Due",
			buyers: "Buyers",
			suppliers: "Suppliers",
			invoices: "Invoices",
			guide: "Guide",
			min: "min",
			max: "max",
			passwordResetOk: "Your password has been reset. Check your email.",
			passwordResetFail: "This link is invalid or expired.",
			billing: "Billing",
			dragdrop: 'Drag files here',
			recordPayment: "Record payment",
			tourNoServices: "There are no supplier services defined for this tour.",
			balancesNotPaid: "Tour not fully paid",
			balancesPaid: "Fully paid tour",
			depositsNotPaid: "Not all deposits payed",
			depositsPaid: "All deposits payed",
			formsNotSent: "Boking forms not sent to all guests",
			formsSent: "Boking forms sent to all guests",
			separation: "Separate with ;",
			servicesPaid: "Suppliers fully paid",
			servicesNotPaid: "Suppliers not fully paid",
			invoicesEmailPopup: "Save and email invoice",
			toursGroupsEmailPopup: "Send booking form",
			toursGroupsGuestsEmailPopup: "Resend booking form",
			prepaidAmount: "Prepaid amount"
		},
		tabs: {
			general: "General",
			billingGroups: "Billing groups",
			suppliers: "Suppliers",
			tourProfit: "Tour profit",
			buyerTours: "Buyer tours",
			supplierTours: "Supplier tours",
			people: "People"
		},
		modules: {
			login: "Login",
			dashboard: "Dashboard",
			tours: "Tours",
			finance: "Finance",
			invoices: "Invoices",
			payments: "Payments",
			reporting: "Reporting",
			cashFlowBuyers: "Cash flow - buyers",
			cashFlowSuppliers: "Cash flow - suppliers",
			tourProfit: "Tour profit",
			lists: "Lists",
			people: "People",
			companies: "Companies",
			destinations: "Destinations",
			tourCategories: "Tour categories",
			supplierServices: "Supplier services",
			supplierServiceTypes: "Supplier service types",
			paymentAccounts: "Payment accounts",
			settings: "Settings",
			userAccounts: "User accounts",
			profile: "My profile",
			newPerson: "New person",
			newCompany: "New company",
			newDestination: "New destination",
			newTourCategory: "New tour category",
			newServiceType: "New service type",
			newSupplierService: "New supplier service",
			newPaymentAccount: "New payment account",
			newUserAccount: "New user account",
			newInvoice: "New invoice",
			newTour: "New tour"
		},
		fields: {
			firstName: "First name",
			lastName: "Last name",
			name: "Name",
			oib: "OIB",
			email: "E-mail",
			address: "Address",
			city: "City",
			country: "Country",
			password: "Password",
			rememberMe: "Remember me",
			passwordConfirmation: "Password repeated",
			passwordChange: "Password change",
			oldPassword: "Old password",
			newPassword: "New password",
			newPasswordConfirmation: "Repeated new passsword",
			active: "Active",
			phone: "Phone",
			type: "Type",
			notes: "Notes",
			documents: "Documents",
			subjectType: "Buyer/Supplier",
			dateAdded: "Date Added",
			oibVat: "OIB/VAT",
			contactPerson: "Contact person",
			bookingFormLink: "Booking form link",
			invoiceAccountItemEn: "Invoice account item (ENG)",
			invoiceAccountItemHr: "Invoice account item (HR)",
			supplierName: "Supplier name",
			serviceType: "Service type",
			serviceName: "Service name",
			price: "Price",
			supplier: "Supplier",
			companyName: "Company name",
			bank: "Bank",
			iban: "Account/IBAN",
			accountName: "Account name",
			web: "Web",
			logo: "Logo",
			role: "Role",
			number: "Number",
			buyer: "Buyer",
			invoiceDateAndTime: "Invoice date and time",
			paymentDueDate: "Payment due date",
			account: "Account",
			eurRate: "EUR rate",
			item: "Item",
			total: "Total",
			quantity: "Quantity",
			footer: "Footer",
			invoiceDate: "Invoice date",
			buyerName: "Buyer name",
			dueDate: "Due date",
			totalAmount: "Total amount",
			invoiceNumber: "Invoice number",
			date: "Date",
			amount: "Amount",
			id: "ID",
			category: "Category",
			destination: "Destination",
			startDate: "Start date",
			endDate: "End date",
			meetingPoint: "Meeting point",
			departure: "Departure",
			pricePerPerson: "Price per person",
			guides: "Guides",
			guideNotes: "Guide notes",
			guest: "Guest",
			paymentAccount: "Payment account",
			paidAmount: "Paid amount",
			datePaid: "Date paid",
			transactionId: "TransactionID",
			guests: "Guests",
			bookingStatus: "Booking status",
			tripStatus: "Trip status",
			tourName: "Tour name",
			tourDestination: "Tour destination",
			persons: "Persons",
			totalTripValue: "Total trip value",
			totalGrossProfit: "Total gross profit",
			cost: "Cost",
			totalValue: "Total value",
			recipients: "Recipients",
			subject: "Subject",
			message: "Message",
			tourStartDate: "Tour start date",
			tourCategory: "Tour category",
			paymentDate: "Payment date",
			account: "Account",
			tourId: "Tour ID",
			dateOfIssue: "Date of issue",
			depositDue: "Deposit due",
			depositDueDate: "Deposit due date",
			balanceDue: "Balance due",
			balanceDueDate: "Balance due date",
			invoice: "Invoice",
			transactionId: "Transaction ID",
			supplierService: "Supplier service",
			paidDate: "Date paid",
			unpaidAmount: "Unpaid amount",
			nights: "Nights",
			totalTourIncome: "Total tour income",
			totalTourCost: "Total tour cost",
			totalGrossProfitPercentage: "Total tour gross profit %",
			swift: "SWIFT",
			completelyPaid: "Completely paid",
			depositPaid: "Deposit paid",
			balancePaid: "Balance paid",
			bookingFormsSent: "Booking forms sent",
			depositsPaid: "Deposits paid",
			paymentMethod: "Payment method",
			servicesPaid: "Suppliers fully paid",
			company: "Company",
			people: "People",
			emailAddress: "E-mail address",
			billingPersonCompany: "Billing person/company",
			cc: "CC",
			bcc: "BCC",
			fullyPaid: "Fully paid"
		},
		alerts: {
			removalQuestion: "Are you sure that you want to remove this record?",
			deletionQuestion: "Are you sure that you want to delete this record?",
			removalQuestion: "Are you sure that you want to remove this item?",
			removalQuestionNoUndo: "Are you sure that you want to remove this item? You cannot undo this step!",
			fileDeletionQuestion: "Are you sure that you want to delete this file?",
			emailMissing: "You did not enter e-mail.",
			emailFailFormat: "E-mail is in the wrong format.",
			passwordMissing: "You did not enter password.",
			passwordFailConfirmation: "Passwords do not match.",
			passwordResetSuccess: "New password was sent to entered e-mail address.",
			passwordResetFail: "New users were found with entered e-mail address.",
			basicUpdate: "Changes saved.",
			basicDelete: "Record deleted.",
			basicAdd: "Record added.",
			basicError: "There was an error on the server.",
			oldPasswordFail: "Old password is not valid.",
			loginFail: "Invalid credentials.",
			fieldError: "This field is mandatory.",
			oibError: "Entered OIB is not valid.",
			invoiceSequenceLater: "You can not save this invoice because another invoice with lower number and greater time of issue exists.",
			invoiceSequenceEarlier: "You can not save this invoice because another invoice with greater number and lower time of issue exists.",
			invoiceInvalidYear: "You can not change invoice's year.",
			personOnTheList: "Selected person is already on the list.",
			groupDeletionInvoiceExists: "This group has na invoice. Cancel the invoice before deleting the group.",
			tourCancelQuestion: "Are you sure that you want to cancel this tour? This step cannot be undone, storno invoice, storno suppliers!",
			tourInvoiceCancelQuestion: "Would you like to cancel invoice %number% with amount of %amount% including tax?",
			emailSent: "Email sent.",
			markAsPaidQuestionMultiple: "Are you sure that you want to mark selected records as paid?",
			invoiceMaxItems: "You cannot add more than 15 items to an invoice.",
			logoutQuestion: "Are you sure that you want to log out?",
			passwordLength: "Password needs to have at least 8 characters.",
			userExists: "User with that email already exists.",
			leaveQuestion: "Are you sure that you want to leave without saving changes?",
			endDateError: "Start date can not be later than end date.",
			invoiceItemError: "Every item needs to have a name.",
			depositDueDateError: "Deposit due date needs to be before balance due date.",
			personOnTheTour: "This person is alredy a guest on this tour.",
			bookingResend: "Booking form already sent. Would you like to resed?",
			bookingSent: "Booking form sent.",
			recalculate: "Are you sure you want to overwrite current values?",
			recipientsError: "Recipients are not entered or in the wrong format.",
			bookingFormQuestion: "Would you like to send booking form to all guests in this group?",
			markAsPaidQuestionSingle: "Are you sure that you want to mark this record as paid?",
			invoiceGroupAmountQuestion: "Invoice's total amount is greater than the tour group's total amount. Do you want to proceed?",
			invoiceCancellationQuestion: "Are you sure you want to cancel this invoice?",
			prepaidQuestion: "Do you want to transfer existing prepaid amount to this invoice?"
		},
		buttons: {
			login: "Login",
			logout: "Logout",
			profile: "My profile",
			new: "New",
			save: "Save",
			add: "Add",
			cancel: "Cancel",
			yes: "Yes",
			no: "No",
			ok: "OK",
			all: "All",
			delete: "Delete",
			back: "Back",
			close: "Close",
			forgottenPassword: "Forgotten password?",
			addPerson: "Add person",
			addCompany: "Add company",
			addDestination: "Add destination",
			addTourCategory: "Add tour category",
			addServiceType: "Add service type",
			addSupplierService: "Add supplier service",
			addPaymentAccount: "Add payment account",
			addUserAccount: "Add user account",
			addInvoice: "Add invoice",
			addItem: "Add item",
			showHideFooterDetails: "Footer details",
			updateSubject: "Update buyer data",
			addTour: "Add tour",
			cancelTour: "Cancel Tour",
			addGroup: "New Group",
			sendBookingForm: "Booking Form",
			addNewGuests: "New Guests",
			addExistingGuest: "Existing Guest",
			calculate: "Calculate",
			createInvoice: "Create Invoice",
			createOffer: "Create Offer",
			recalculate: "Recalculate",
			openInvoice: "Open Invoice",
			openOffer: "Open Offer",
			addPayment: "Add Payment",
			saveAndEmail: "Save & Email",
			saveAndPrint: "Save & Print (PDF)",
			markAsPaid: "Mark as paid",
			assignGuide: "Assign guide",
			saveAndBookingPdf: "Save & open booking PDF",
			excel: "Excel",
			send: "Send",
			deleteGroup: "Delete group",
			saveAndMore: "Save and add more"
		},
		texts: {
			passwordReset: "Enter e-mail to reset password."
		},
		tooltips: {
			logout: "Logout",
			excel: "Excel",
			pdf: "PDF",
			filter: "Filter",
			addPerson: "Add person",
			addCompany: "Add company",
			openInNewTab: "Open in new tab",
			removeGuest: "Remove person from billing group",
			uploadFile: "Upload file",
			removeFile: "Remove file",
			recordPayment: "Record payment",
			deleteInvoice: "Delete invoice",
			removeItem: "Remove item",
			deleteSupplierService: "Delete supplier service",
			viewGuest: "View guest profile",
			sendBookingForm: "Booking form sent. Click to resend to this guest.",
			markTour: "Select tours to assign guide"
		}
	}
}

